(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-data/store/assets/reducers/create-bet-proposal-reducer.js') >= 0) return;  svs.modules.push('/components/marketplace-data/store/assets/reducers/create-bet-proposal-reducer.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const products = svs.utils.products;
const getBetProposalRowId = svs.components.marketplace.helpers.getRowId;
const _svs$components$marke = svs.components.marketplaceData.createBetProposal.actions,
  TOGGLE_OUTCOME = _svs$components$marke.TOGGLE_OUTCOME,
  CLEAR_ROW = _svs$components$marke.CLEAR_ROW,
  BET_PROPOSAL_CREATE_INIT = _svs$components$marke.BET_PROPOSAL_CREATE_INIT,
  BET_PROPOSAL_CREATE_SUCCESS = _svs$components$marke.BET_PROPOSAL_CREATE_SUCCESS,
  BET_PROPOSAL_CREATE_FAILURE = _svs$components$marke.BET_PROPOSAL_CREATE_FAILURE,
  BET_PROPOSAL_UPDATE_INIT = _svs$components$marke.BET_PROPOSAL_UPDATE_INIT,
  BET_PROPOSAL_UPDATE_SUCCESS = _svs$components$marke.BET_PROPOSAL_UPDATE_SUCCESS,
  BET_PROPOSAL_UPDATE_FAILURE = _svs$components$marke.BET_PROPOSAL_UPDATE_FAILURE,
  BET_PROPOSAL_CLEAR = _svs$components$marke.BET_PROPOSAL_CLEAR;
const FETCH_BET_PROPOSAL_SUCCESS = svs.components.marketplaceData.betProposal.actions.FETCH_BET_PROPOSAL_SUCCESS;
const FETCH_PRODUCTS_DRAWS_SUCCESS = svs.components.marketplaceData.draws.actions.FETCH_PRODUCTS_DRAWS_SUCCESS;
const LOAD_FROM_LOCAL_STORAGE = svs.components.marketplaceData.localStorage.actions.LOAD_FROM_LOCAL_STORAGE;
const intitalState = {
  data: {},
  isCreating: undefined,
  createError: undefined,
  betProposalIsPrivate: undefined
};
const reducer = function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let action = arguments.length > 1 ? arguments[1] : undefined;
  const timestamp = action.timestamp || new Date().getTime();
  switch (action.type) {
    case FETCH_BET_PROPOSAL_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        [action.activatedDrawId]: _objectSpread(_objectSpread({}, state[action.activatedDrawId]), {}, {
          timestamp,
          data: action.betProposal
        })
      });
    case TOGGLE_OUTCOME:
      {
        var _eventRow$participant;
        const activatedDrawId = action.activatedDrawId,
          drawNumber = action.drawNumber,
          eventNumber = action.eventNumber,
          outcomeNumber = action.outcomeNumber,
          productName = action.productName,
          participantNumber = action.participantNumber,
          groupId = action.groupId;
        const rowId = activatedDrawId || getBetProposalRowId(productName, drawNumber, groupId);
        const row = (state[rowId] || {}).data || {};
        const eventRow = row[eventNumber] || {};
        return _objectSpread(_objectSpread({}, state), {}, {
          [rowId]: {
            timestamp,
            data: _objectSpread(_objectSpread({}, row), {}, {
              [eventNumber]: _objectSpread(_objectSpread({}, eventRow), participantNumber !== undefined ? {
                [participantNumber]: _objectSpread(_objectSpread({}, eventRow[participantNumber]), {}, {
                  [outcomeNumber]: !((_eventRow$participant = eventRow[participantNumber]) !== null && _eventRow$participant !== void 0 && _eventRow$participant[outcomeNumber])
                })
              } : {
                [outcomeNumber]: !eventRow[outcomeNumber]
              })
            })
          }
        });
      }
    case CLEAR_ROW:
      {
        const activatedDrawId = action.activatedDrawId,
          productName = action.productName,
          drawNumber = action.drawNumber,
          groupId = action.groupId;
        const rowId = activatedDrawId || getBetProposalRowId(productName, drawNumber, groupId);
        return _objectSpread(_objectSpread({}, state), {}, {
          [rowId]: _objectSpread(_objectSpread({}, state[rowId]), {}, {
            timestamp,
            data: {}
          })
        });
      }
    case FETCH_PRODUCTS_DRAWS_SUCCESS:
      {
        if (products.helpers.isRacing(action.productName)) {
          return state;
        }
        return Object.keys(state).filter(betProposalKey => {
          const _betProposalKey$split = betProposalKey.split('_'),
            _betProposalKey$split2 = _slicedToArray(_betProposalKey$split, 3),
            groupId = _betProposalKey$split2[0],
            productName = _betProposalKey$split2[1],
            drawNumber = _betProposalKey$split2[2];
          if (productName !== action.productName) {
            return true;
          }
          if (groupId !== action.groupId) {
            return true;
          }
          let isDrawOpen = false;
          for (let i = 0; i < action.draws.length; ++i) {
            if (action.draws[i].drawNumber !== parseInt(drawNumber, 10)) {
              continue;
            }
            if (action.draws[i].drawStateId <= 2) {
              isDrawOpen = true;
              break;
            }
          }
          return isDrawOpen;
        }).reduce((obj, prop) => _objectSpread(_objectSpread({}, obj), {}, {
          [prop]: state[prop]
        }), {});
      }
    case BET_PROPOSAL_CREATE_INIT:
      {
        const productName = action.productName,
          drawNumber = action.drawNumber,
          groupId = action.groupId,
          activatedDrawId = action.activatedDrawId,
          betProposalIsPrivate = action.betProposalIsPrivate;
        const rowId = activatedDrawId || getBetProposalRowId(productName, drawNumber, groupId);
        return _objectSpread(_objectSpread({}, state), {}, {
          [rowId]: _objectSpread(_objectSpread({}, state[rowId]), {}, {
            timestamp,
            isCreating: true,
            createError: undefined,
            betProposalIsPrivate
          })
        });
      }
    case BET_PROPOSAL_CREATE_SUCCESS:
      {
        return intitalState;
      }
    case BET_PROPOSAL_CREATE_FAILURE:
      {
        const productName = action.productName,
          drawNumber = action.drawNumber,
          groupId = action.groupId;
        const rowId = getBetProposalRowId(productName, drawNumber, groupId);
        return _objectSpread(_objectSpread({}, state), {}, {
          [rowId]: _objectSpread(_objectSpread({}, state[rowId]), {}, {
            timestamp,
            isCreating: false,
            createError: action.error,
            betProposalIsPrivate: false
          })
        });
      }
    case BET_PROPOSAL_UPDATE_INIT:
      return _objectSpread(_objectSpread({}, state), {}, {
        [action.activatedDrawId]: _objectSpread(_objectSpread({}, state[action.activatedDrawId]), {}, {
          timestamp,
          isUpdating: true,
          updateError: undefined
        })
      });
    case BET_PROPOSAL_UPDATE_SUCCESS:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          [action.activatedDrawId]: _objectSpread(_objectSpread({}, state[action.activatedDrawId]), {}, {
            timestamp,
            isUpdating: false,
            updateError: undefined
          })
        });
      }
    case BET_PROPOSAL_UPDATE_FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        [action.activatedDrawId]: _objectSpread(_objectSpread({}, state[action.activatedDrawId]), {}, {
          timestamp,
          isUpdating: false,
          updateError: action.error
        })
      });
    case LOAD_FROM_LOCAL_STORAGE:
      {
        return _objectSpread(_objectSpread({}, state), action.payload.CreateBetProposal);
      }
    case BET_PROPOSAL_CLEAR:
      return intitalState;
    default:
      return state;
  }
};
setGlobal('svs.components.marketplaceData.store.reducers.createBetProposalReducer', reducer);

 })(window);